import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "className"];
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { AlertBadge } from '@box/blueprint-web-assets/icons/Fill';
import { IconIconErrorOnLight, Size4 } from '@box/blueprint-web-assets/tokens/tokens';
import clsx from 'clsx';
import { forwardRef } from 'react';
import styles from './inline-error.module.js';
/** Renders an inline error message and icon, used to show error state in form elements. */

var InlineError = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var children = props.children,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  return jsx("span", _objectSpread(_objectSpread({}, rest), {}, {
    ref: forwardedRef,
    className: clsx([className, styles.inlineError, _defineProperty({}, styles.empty, !children)]),
    children: children && jsxs(Fragment, {
      children: [jsx(AlertBadge, {
        className: styles.errorIcon,
        color: IconIconErrorOnLight,
        height: Size4,
        role: "presentation",
        width: Size4
      }), children]
    })
  }));
});
export { InlineError };